
export {
    init,
    touch,
}

const joystickEl = document.querySelector('.joystick');
const joystickSize = 60;

const touch = {
    active: false,
    startX: 0,
    startY: 0,
    xAxis: 0,
    yAxis: 0,
};

function init () {
    // Register touch events
    window.addEventListener('touchstart', (e) => {
        touch.active = true;
        touch.startX = e.touches[0].clientX;
        touch.startY = e.touches[0].clientY;
        joystickEl.style.translate = `${touch.startX - joystickSize / 2}px ${touch.startY - joystickSize / 2}px`;
        joystickEl.style.opacity = 0.5;
    });
    window.addEventListener('touchmove', (e) => {
        const halfJoy = joystickSize / 2;

        // Get touch move position
        let moveX = e.touches[0].clientX;
        let moveY = e.touches[0].clientY;

        // Calculate joystick delta
        let deltaX = moveX - touch.startX;
        let deltaY = moveY - touch.startY;

        // Calculate joystick distance
        const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);

        // Constrain joystick to its size
        if (distance > halfJoy) {
            const angle = Math.atan2(deltaY, deltaX);
            deltaX = Math.cos(angle) * halfJoy;
            deltaY = Math.sin(angle) * halfJoy;
            moveX = touch.startX + deltaX;
            moveY = touch.startY + deltaY;
        }

        touch.xAxis = deltaX / halfJoy;
        touch.yAxis = deltaY / halfJoy;

        // Update joystick position
        joystickEl.style.translate = `${moveX - halfJoy}px ${moveY - halfJoy}px`;
    });
    window.addEventListener('touchend', (e) => {
        touch.active = false;
        joystickEl.style.opacity = 0;
    });
}
